"use client";

import { useMemo, useRef } from "react";

import type { CheckoutProviderProps } from "./Checkout.context";
import { CheckoutContext } from "./Checkout.context";

export const CheckoutProvider = ({
  children,
  madeToOrderBlock,
  eurobonusBlock,
  details,
}: CheckoutProviderProps) => {
  const deliveryStepRef = useRef<HTMLFormElement | null>(null);
  const paymentStepRef = useRef<HTMLDivElement | null>(null);
  const adyenDropInRef = useRef<HTMLDivElement | null>(null);
  const walleyWidgetRef = useRef<HTMLDivElement | null>(null);

  const value = useMemo(
    () => ({
      details,
      madeToOrderBlock,
      eurobonusBlock,
      adyenDropInRef,
      walleyWidgetRef,
      deliveryStepRef,
      paymentStepRef,
    }),
    [
      details,
      madeToOrderBlock,
      eurobonusBlock,
      adyenDropInRef,
      walleyWidgetRef,
      deliveryStepRef,
      paymentStepRef,
    ],
  );

  return (
    <CheckoutContext.Provider value={value}>
      {children}
    </CheckoutContext.Provider>
  );
};
